// public/scripts/krida-ui-harvest.js - Harvest Area rendering logic

import { createStackContainer } from './stack-container.js';
import { getCardPointValue, SUIT_SYMBOLS, getCardNumericValue } from './krida-patra-helpers.js';

let elements = {}; // Cache elements relevant to harvest area

// Create helpers object for stack container
const helpers = {
  getCardPointValue,
  SUIT_SYMBOLS,
  getCardNumericValue
};

export function init(dependencies) {
    console.log("KridaUIHarvest: Initializing...");
    elements.harvestContent = dependencies.elements?.harvestContent;

    // Validate
    if (!elements.harvestContent) console.error("KridaUIHarvest: Missing dependency: elements.harvestContent");
    if (!createStackContainer) console.error("KridaUIHarvest: Missing dependency: createStackContainer (import failed?)");

    console.log("KridaUIHarvest: Initialized.");
}

// Update harvested cards display
export function updateHarvest(harvests) {
    console.log("KridaUIHarvest: updateHarvest ENTRY POINT with data:", harvests);

    if (!elements.harvestContent) {
        console.error("KridaUIHarvest: Harvest content element not found");
        return;
    }
    // --- Validation moved from krida-ui.js ---
    if (typeof createStackContainer !== 'function') {
        console.error("KridaUIHarvest: createStackContainer function not available (import failed?)!");
        // How to show error? Maybe return false?
        return;
    }

    elements.harvestContent.innerHTML = '';

    if (!harvests || harvests.length === 0) {
        console.log("KridaUIHarvest: No harvests to display");
        const emptyMessage = document.createElement('div');
        emptyMessage.className = 'empty-harvest-message';
        emptyMessage.textContent = 'No cards harvested yet.';
        elements.harvestContent.appendChild(emptyMessage);
        return;
    }

    console.log(`KridaUIHarvest: updateHarvest received ${harvests.length} harvest actions...`);
    harvests.forEach((harvest, index) => {
        console.log(`KridaUIHarvest: Rendering harvest stack ${index + 1} using createStackContainer with data:`, JSON.parse(JSON.stringify(harvest)));
        if (!harvest || !harvest.cards || harvest.cards.length === 0) {
            console.warn(`KridaUIHarvest: Skipping empty or invalid harvest object at index ${index}`, harvest);
            return;
        }

        // --- Use Reusable Stack Container --- 
        const config = {
            type: 'harvest',
            helpers: helpers, // Add the helpers object
            cards: harvest.cards,
            harvestPoints: harvest.points,
            isBoardClear: harvest.clearedBoard,
            scale: 1.0 // Assuming same scale for harvest
        };

        const containerResult = createStackContainer(harvest.cards, config);

        if (containerResult && containerResult.element) {
            elements.harvestContent.appendChild(containerResult.element);
        } else {
            console.error(`KridaUIHarvest: Failed to create stack container for harvest index ${index}`);
            // Optionally append an error placeholder
            const errorPlaceholder = document.createElement('div');
            errorPlaceholder.textContent = '[Error]';
            errorPlaceholder.style.color = 'red';
            errorPlaceholder.style.border = '1px dashed red';
            errorPlaceholder.style.display = 'inline-block';
            errorPlaceholder.style.padding = '10px';
            errorPlaceholder.style.margin = '5px';
            elements.harvestContent.appendChild(errorPlaceholder);
        }
        // --- End Reusable Stack Container --- 

    });

    // --- Keep Total Cards Harvested ---
    let totalHarvestedCards = 0;
    harvests.forEach(h => totalHarvestedCards += h.cards.length);
    const totalElement = document.createElement('div');
    totalElement.className = 'harvest-total';
    totalElement.textContent = `${totalHarvestedCards} Cards Harvested`;
    // elements.harvestContent.appendChild(totalElement);

    console.log("KridaUIHarvest: Harvest updated with", harvests.length, "harvest actions and", totalHarvestedCards, "total cards.");
} 